<script lang="ts">
  import { buttonVariants } from "$lib/components/ui/button";

  interface Props {
    label: string;
    multiple?: boolean;
    onSelect: (files: File[]) => void;
  }
  const { label, multiple = false, onSelect }: Props = $props();

  function handleChange(e: Event) {
    const input = e.target as HTMLInputElement;
    if (input.files) onSelect(Array.from(input.files));
    input.value = "";
  }
</script>

<label
  class={buttonVariants({ variant: "default", size: "lg" }) +
    " h-12 cursor-pointer rounded-full bg-primary px-5 font-black text-primary-foreground shadow-[0_14px_38px_oklch(0.84_0.144_83/0.22)] hover:bg-primary"}
>
  {label}
  <input
    type="file"
    accept="image/*"
    capture="environment"
    {multiple}
    onchange={handleChange}
    class="sr-only"
  />
</label>
